import React from "react";
import style from "./../Items.module.scss";
import { FormattedDate } from "react-intl";

const PostItem = ({ user, date, message, files, downloadFile }) => {
  const download = (file) => {
    downloadFile(
      {
        eventId: file.eventId,
        eventHistoryId: file.eventHistoryId,
        eventHistoryFileId: file.id,
      },
      (r) => {
        if (r.url != "") {
          window.open(r.url);
        }
      }
    );
  };

  return (
    <div className={style.post}>
      <p style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
        <span className={style.user}>{user}</span>
        {message}
      </p>

      <span>
        <FormattedDate value={date}  timeZone="UTC" />
      </span>

      {files.map((f) => (
        <span key={`f-${f.id}`} className={style.smFile} onClick={() => download(f)}>
          <i className="fa fa-file-code-o ml-2 mr-1" aria-hidden="true"></i>
          {f.name}
        </span>
      ))}
    </div>
  );
};

export default PostItem;
